module.exports = __webpack_public_path__ + "static/img/4.d06a8d55.jpeg";